'use strict';

angular.module('formonlineApp')
    .config(function ($stateProvider) {
        $stateProvider.state('delaifidu', {
            parent: 'fullwidth',
            url: '/delaifidu/{locale}',
            views: {
                'content@': {
                    templateUrl: 'scripts/app/form/delaifidu/delaifidu.html',
                    controller: 'DelaifiduController'
                }
            }
        });
    });
